import React from 'react'
import {IconButton, makeStyles, Typography} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(() => ({
    existPatient:{
        background:'#5571C6', 
        width:"100%", 
        paddingTop:"2px"
    },
    existPatientCheck:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"space-between", 
        // cursor:'pointer'
    },
    existPatientHeader1:{
        fontSize: '24px', 
        fontFamily: 'Inter',
        color: '#fff',
        padding :"8px 10px",
        fontWeight: "450",
        
    },
    reasonForVisit:{
        resize: 'none',
        display: 'inline-flex',
        height: '312px',
        alignItems: 'center',
        flexShrink: '0',
        borderRadius: '5px',
        border: '1px solid #d0d0d0',
        background: '#fff',
        width: '99%',
        // color: '#667689',
        fontFamily: 'Inter',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '500',
        padding: '10px 0px 10px 10px',
        '@media (max-width: 768px)': {
            width: '96%',
            padding: '5px',
        },

    },
    container: {
        width: '100%',
    },
}))
const ReasonForVisitModal = ({reasonForVisitText, setReasonForVisitText, onClose}) => {
    const classes = useStyles()
    return (
        <>
            <div>
                <div className={classes.existPatient}>
                    <div className={classes.existPatientCheck} style={{ padding: '0px 8px' }}>
                        <Typography className={classes.existPatientHeader1}>
                            What is the reason for your visit?
                        </Typography>
                        <IconButton onClick={onClose}>
                            <CloseIcon style={{color: '#fff'}}/>
                        </IconButton>
                    </div>
                </div>
                <div style={{padding: '23px'}}>
                    <textarea
                        placeholder="In a few words please describe your reason for this visit. "
                        className={classes?.reasonForVisit}
                        value={reasonForVisitText}
                        onChange={(event) => setReasonForVisitText(event.target.value)}
                    />
                </div>
            </div>
        </>
    )
}
export default ReasonForVisitModal